module.exports = __webpack_public_path__ + "assets/69de982d12fd73689b29011cfd2d9d0f.mp3";